module.exports = __webpack_public_path__ + "img/touping-gou.04d326fd.png";